module.exports = __webpack_public_path__ + "static/media/top7.8930bc65.mp3";